<template>
  <div>
    <images-dialog
      ref="imagesDialog"
      :extensions="extensions"
      @submit="dialogSubmitted"
    />
    <image-edit-dialog
      ref="imageEditDialog"
      :key="value"
      @formSubmitted="fetchSelectedImage"
    />
    <div class="box">
      <img
        v-if="selectedImage"
        class="thumbnail"
        :src="src"
        :alt="selectedImage.title"
      />
      <div class="image-info">
        <el-button
          v-if="selectedImage"
          type="info"
          class="edit-button"
          @click="openEditImageDialog"
        >
          <i class="fa fa-edit"></i> Edytuj zdjęcie
        </el-button>
        <el-button type="info" class="open-dialog-button" @click="openDialog">
          <i class="fa fa-file-image-o"></i> Wybierz lub prześlij zdjęcie
        </el-button>
      </div>
      <el-button
        v-if="value"
        class="remove-button"
        size="mini"
        icon="el-icon-delete"
        type="danger"
        title="Usuń zdjęcie"
        @click.stop="removeImage"
      >
      </el-button>
    </div>
    <el-alert v-if="help" show-icon :closable="false" :title="help" />
  </div>
</template>
<script>
import ImagesDialog from '@/components/inputs/ImageDialog/'
import ImageEditDialog from '@/components/inputs/ImageDialog/ImageEditDialog'
import { Image } from '@/api'

export default {
  components: {
    ImagesDialog,
    ImageEditDialog
  },
  props: {
    value: {
      type: undefined
    },
    help: {
      type: undefined
    },
    extensions: {
      type: Array,
      default: () => ['.jpg', '.jpeg', '.png', '.webp']
    }
  },
  data() {
    return {
      selectedImage: null
    }
  },
  computed: {
    src() {
      const thumbnail = this.selectedImage.thumbnail
      return thumbnail ? thumbnail.url : this.selectedImage.file_url
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        value ? this.fetchSelectedImage() : (this.selectedImage = null)
      }
    }
  },
  methods: {
    removeImage() {
      this.$emit('input', null)
    },
    openDialog() {
      this.$refs.imagesDialog.openDialog()
    },
    dialogSubmitted(image) {
      this.$emit('input', image)
    },
    fetchSelectedImage() {
      Image.get({ id: this.value }).then(response => {
        this.selectedImage = response.data
      })
    },
    openEditImageDialog() {
      this.$refs.imageEditDialog.openDialog(this.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.remove-button {
  position: absolute;
  right: 28px;
  top: 28px;
}

.open-dialog-button,
.edit-button {
  vertical-align: middle;
}

.thumbnail {
  max-width: 140px;
  vertical-align: middle;
}

.image-info {
  display: inline-block;
  vertical-align: middle;
  margin-left: 20px;

  &__title {
    font-weight: 700;
  }

  &__edit-image-icon {
    cursor: pointer;
    vertical-align: middle;
  }
}
</style>
